var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"relative inline-block"},[_c('button',_vm._g(_vm._b({staticClass:"relative z-10 button-text flex content-center w-full h-full text-black focus:outline-none",class:{
      'bg-blue-400 hover:bg-blue-500 focus:bg-blue-500': _vm.theme === 'blue',
      'bg-orange-400 hover:bg-orange-500 focus:bg-orange-500':
        _vm.theme === 'orange',
      'bg-gray-400 hover:bg-blue-400 focus:bg-blue-400': _vm.theme === 'gray',
      'bg-white hover:bg-gray-100 focus:bg-gray-100': _vm.theme === 'white',
      'text-white bg-red-600 hover:bg-red-700 focus:bg-red-700':
        _vm.theme === 'red',
      'bg-gray-300 hover:bg-blue-300 focus:bg-blue-300':
        _vm.$attrs.disabled || _vm.loading,
      'button-text-loading': _vm.loading,
      'px-12 py-4 text-xl': _vm.size === 'large',
      'px-4 py-2': _vm.size === 'base',
      'px-2 py-1 text-sm': _vm.size === 'small',
      uppercase: _vm.uppercase,
    }},'button',_vm.$attrs,false),_vm.$listeners),[_vm._t("default")],2),_c('base-loading',{staticClass:"absolute left-0 top-1/2 transform -translate-y-1/2"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }